import React, { useState } from "react";
import AdicionarAoCarrinhoBtn from "../AdicionarAoCarrinhoBtn";

const PriceCardRadio = ({ ebook }) => {
    const hasEbook = !!ebook.preco;
    const hasFisico = !!ebook.preco_impresso;

    const [formato, setFormato] = useState(hasFisico ? "fisico" : "ebook");
    const [cep, setCep] = useState("");
    const [mostrarFrete, setMostrarFrete] = useState(false);
    const [quantidade, setQuantidade] = useState(1); // Substitua por lógica real

    const [freteSelecionado, setFreteSelecionado] = useState("20");
    const precoFisico = hasFisico ? parseFloat(ebook.preco_impresso) : null;
    const precoEbook = hasEbook ? parseFloat(ebook.preco) : null;

    const precoSelecionado = formato === "fisico" ? precoFisico : precoEbook;
    const precoPix = formato === "fisico" ? precoSelecionado - 5 : precoSelecionado;

    const itemCarrinho = {
        id: ebook.id,
        titulo: ebook.titulo,
        image: ebook.image,
        preco: precoSelecionado,
        formato,
    };

    const handleCalcularFrete = () => {
        if (cep.length >= 8) {
            setMostrarFrete(true);
        } else {
            alert("Por favor, insira um CEP válido.");
        }
    };

    return (
        <div style={{
            backgroundColor: "#1B1F54",
            color: "#fff",
            display: "flex",
            borderRadius: "4px",
            maxWidth: "550px",
            marginTop: "14px",
            fontFamily: "sans-serif"
        }} >

            {/* Coluna de opções */}
            <div style={{ flex: 1 }} className="price-card">
                {hasFisico && (
                    <div
                        onClick={() => setFormato("fisico")}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            backgroundColor: formato === "fisico" ? "rgb(36, 36, 99)" : "transparent",
                            width: "100%",
                            padding: "24px",
                            
                        }}
                    >
                        <input
                            type="radio"
                            name="formato"
                            value="fisico"
                            checked={formato === "fisico"}
                            onChange={() => setFormato("fisico")}
                            style={{ marginRight: "0.5rem" }}
                        />
                        <div>
                            <div style={{ fontWeight: "bold" }}>Livro Físico</div>
                            <div>R$ {precoFisico.toFixed(2)}</div>
                        </div>
                    </div>
                )}

                {hasEbook && (
                    <div
                        onClick={() => setFormato("ebook")}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            backgroundColor: formato === "ebook" ? "rgb(36, 36, 99)" : "transparent",
                            width: "100%",
                            padding: "24px",
                            borderTopLeftRadius: !hasFisico ? "4px" : "0px"
                        }}
                    >
                        <input
                            type="radio"
                            name="formato"
                            value="ebook"
                            checked={formato === "ebook"}
                            onChange={() => setFormato("ebook")}
                            style={{ marginRight: "0.5rem" }}
                        />
                        <div>
                            <div style={{ fontWeight: "bold" }}>Ebook</div>
                            <div>R$ {precoEbook.toFixed(2)}</div>
                        </div>
                    </div>
                )}
            </div>

            {/* Coluna de preço e ações */}
            <div style={{
                flex: 1,
                paddingLeft: "1rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                backgroundColor: "#242463",
                padding: "32px",
                borderRadius: "4px",
                borderTopLeftRadius: "0px"
            }}>
                <div>
                    <div style={{ fontSize: "50px", fontWeight: "bold", marginBottom: "32px" }}>
                        R$ {precoSelecionado.toFixed(2)}
                    </div>

                    {formato === "fisico" && (
                        <>
                            <div style={{
                                display: "flex",
                                gap: "0.5rem",
                                marginBottom: "32px",
                                border: "1px solid #ffffff75",
                                borderRadius: "4px",
                                padding: "0.5rem"
                            }}>
                                <input
                                    type="text"
                                    placeholder="Insira seu CEP"
                                    value={cep}
                                    onChange={(e) => setCep(e.target.value)}
                                    style={{
                                        flex: 1,
                                        padding: "0.5rem",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                        border: "none",
                                        outline: "none",
                                        backgroundColor: "transparent",
                                        color: "rgb(255 255 255 / 75%)",
                                    }}
                                />
                                <button
                                    onClick={handleCalcularFrete}
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "0.5rem 1rem",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        
                                    }}
                                >
                                    Calcular
                                </button>
                            </div>

                            {mostrarFrete && (
                                quantidade > 10 ? (
                                    <div style={{ marginBottom: "32px" }}>
                                        <p>Para mais de 10 unidades, entre em contato:</p>
                                        <a
                                            href="https://wa.link/o4jzw4"
                                            alt="whatsapp link"
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: "#25D366", fontWeight: "bold", fontSize: "18px" }}
                                        >
                                            <i className="uil uil-whatsapp whats-btn" /> WhatsApp
                                        </a>
                                    </div>
                                ) : (
                                    <div style={{ marginBottom: "32px", }}>
                                        <p style={{ marginBottom: "6px" }}>Escolha o frete:</p>
                                        <label style={{ display: "block", marginBottom: "6px" }}>
                                            <input
                                                type="radio"
                                                name="frete"
                                                value="20"
                                                checked={freteSelecionado === "20"}
                                                onChange={() => setFreteSelecionado("20")}
                                                style={{ marginRight: "8px" }}
                                            />
                                            20 dias úteis - R$ 20,00
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="frete"
                                                value="70"
                                                checked={freteSelecionado === "70"}
                                                onChange={() => setFreteSelecionado("70")}
                                                style={{ marginRight: "8px" }}
                                            />
                                            12 dias úteis - R$ 70,00
                                        </label>
                                    </div>
                                )
                            )}
                        </>
                    )}
                </div>

                <AdicionarAoCarrinhoBtn
                    btnText="COMPRAR AGORA"
                    alt={true}
                    newBtn={true}
                    ebook={itemCarrinho}
                />
            </div>
        </div>
    );
};

export default PriceCardRadio;
